import { createSlice } from "@reduxjs/toolkit";
import { addCMSRole, deleteCMSRole, updateCMSRole } from "../Services/CMSUserRoles/UserRolesAction";

export const initialState = null;

export const reducer = (state, action) => {
  if (action.type === "CMSUSER") {
    return action.payload;
  }
  return state;
};

const cmsUserSlice = createSlice({
  name: "cmsusers",
  initialState,
  reducers: {
    addCMSUser: (state, action) => {
      const { formData, permissions } = action.payload;
      addCMSRole(formData, permissions);
      console.log("Data : ", formData, "gvdschgve = ",permissions);
    },
    updateCMSUser: (state, action) => {
      const { formData, userId, permissions } = action.payload;
      updateCMSRole(formData, userId, permissions);
    },
    deleteCMSUser: (state, action) => {
      deleteCMSRole(action.payload);
    }
  }
});



export const { addCMSUser, updateCMSUser, deleteCMSUser } = cmsUserSlice.actions;
export default cmsUserSlice.reducer;